import fileService from "../../../../services/file";
import websiteService from "../../../../services/website";
import ImagesBox from "./ImagesBox";
import ImageUploader from "./ImageUploader";
import mixin from "../../../../mixins/mixin";
import vrboEnumerations from "./VrboSchemaEnumerations";
import vrboService from "../../../../services/vrbo";
import vrboLodgingConfigEnumerations from "../../../account/settings/VrboDefaultConfigurationTab/VrboLodgingConfigEnumerations";
import Multiselect from "vue-multiselect";

export default {
  name: "VrboConfigurationTab",

  props: ["rental", "vrboAmenitiesFeatures"],

  data() {
    return {
      // listing config
      languages: {
        french: {
          code: "fr",
          name: "french",
        },
        english: {
          code: "en",
          name: "english",
        },
        portuguese: {
          code: "pt",
          name: "portugal",
        },
        spanish: {
          code: "es",
          name: "spanish",
        },
      },
      activeLang: "fr",
      property_name: "",
      headline: "",
      description: "",
      accomodations_summary: "",
      map: {
        latitude: "",
        longitude: "",
        showExactLocation: false,
      },
      vrboBathroomTypes: vrboEnumerations.vrboBathroomTypes,
      vrboBedroomTypes: vrboEnumerations.vrboBedroomTypes,
      vrboAmenitiesSelectedFeatures: {
        sports: [],
        car: [],
        safety: [],
        general: [],
        locations: [],
        attractions: [],
        leisure: [],
        local: [],
        kitchen: [],
        amenities: [],
        entertainment: [],
        pool: [],
        accomodations: [],
        themes: [],
        suitability: [],
      },
      vrboBathroomSelectedFeatures: [
        {
          type: "FULL_BATH",
          name: { fr: "" },
          description: { fr: "" },
          amenities: [],
        },
      ],
      vrboBedroomSelectedFeatures: [
        {
          type: "BEDROOM",
          name: { fr: "" },
          description: { fr: "" },
          amenities: [],
        },
        {
          type: "OTHER_SLEEPING_AREA",
          name: { fr: "" },
          description: { fr: "" },
          amenities: [],
        },
      ],
      vrboPropertyTypes: vrboEnumerations.vrboPropertyTypes,
      vrboPropertySelectedType: "PROPERTY_TYPE_APARTMENT",
      registrationNumber: "000000",
      unitName: "",
      vrboCurrencies: vrboEnumerations.vrboCurrencies,
      vrboSelectedCurrency: "EUR",
      vrboTexts: {
        property_name_fr: "",
        property_name_en: "",
        property_name_pt: "",
        property_name_es: "",
        headline_fr: "",
        headline_en: "",
        headline_pt: "",
        headline_es: "",
        description_fr: "",
        description_en: "",
        description_pt: "",
        description_es: "",
        accomodations_summary_fr: "",
        accomodations_summary_en: "",
        accomodations_summary_pt: "",
        accomodations_summary_es: "",
      },

      image: {
        label: "photo",
        file: {},
      },
      images: [],
      loading: false,
      imageDeleted: false,
      isImageSelected: false,

      // lodging config
      vrboBookingPolicies: vrboLodgingConfigEnumerations.vrboBookingPolicies,
      vrboCancellationPolicies:
        vrboLodgingConfigEnumerations.vrboCancellationPolicies,
      vrboPaymentPolicies: vrboLodgingConfigEnumerations.vrboPaymentPolicies,
      vrboBookingSelectedPolicy: "INSTANT",
      vrboCancellationSelectedPolicy: "NO_REFUND",
      vrboPaymentSelectedPolicy: "PAYMENT_BY_CARD",
      vrboCheckTimes: vrboLodgingConfigEnumerations.vrboCheckTimes,
      vrboDefaultCheckin: "15:00",
      vrboDefaultCheckout: "10:00",
      vrboDefaultChildrenEnabled: true,
      vrboDefaultEventsEnabled: true,
      vrboDefaultPetsEnabled: true,
      vrboDefaultSmokingDisabled: true,
      maximumOccupancyAdults: 5,
      maximumOccupancyGuests: 5,
      merchantName: "",
      minimumAgeRule: 18,
      uploadedFileFile: null,
      uploadedFilePath: null,
      agreementsPdfFile: null,
      agreementsPdfFileUrl: "",
      customHouseRule1: "",
      customHouseRule2: "",
      customHouseRule3: "",
    };
  },

  mixins: [mixin],

  components: {
    ImageUploader,
    ImagesBox,
    VLoading: require("components/loading/loading.vue"),
    Multiselect,
  },

  mounted() {},

  watch: {
    rental(newRental) {
      this.vrboBathroomSelectedFeatures = [];
      for (var i = 0; i < newRental.bathroom_count; i++) {
        this.vrboBathroomSelectedFeatures.push({
          type: "FULL_BATH",
          name: { fr: "" },
          description: { fr: "" },
          amenities: [],
        });
      }

      this.vrboBedroomSelectedFeatures = [];
      for (var i = 0; i < newRental.bedroom_count; i++) {
        this.vrboBedroomSelectedFeatures.push({
          type: "BEDROOM",
          name: { fr: "" },
          description: { fr: "" },
          amenities: [],
        });
      }
      this.vrboBedroomSelectedFeatures.push({
        type: "OTHER_SLEEPING_AREA",
        name: { fr: "" },
        description: { fr: "" },
        amenities: [],
      });

      if (newRental && newRental.vrbo_rental) {
        this.property_name = newRental.vrbo_rental.property_name_fr;
        this.headline = newRental.vrbo_rental.headline_fr;
        this.description = newRental.vrbo_rental.description_fr;
        this.accomodations_summary =
          newRental.vrbo_rental.accomodations_summary_fr;
        // init listings content fields
        this.vrboTexts.property_name_fr =
          newRental.vrbo_rental.property_name_fr;
        this.vrboTexts.property_name_en =
          newRental.vrbo_rental.property_name_en;
        this.vrboTexts.property_name_pt =
          newRental.vrbo_rental.property_name_pt;
        this.vrboTexts.property_name_es =
          newRental.vrbo_rental.property_name_es;
        this.vrboTexts.headline_fr = newRental.vrbo_rental.headline_fr;
        this.vrboTexts.headline_en = newRental.vrbo_rental.headline_en;
        this.vrboTexts.headline_pt = newRental.vrbo_rental.headline_pt;
        this.vrboTexts.headline_es = newRental.vrbo_rental.headline_es;
        this.vrboTexts.description_fr = newRental.vrbo_rental.description_fr;
        this.vrboTexts.description_en = newRental.vrbo_rental.description_en;
        this.vrboTexts.description_pt = newRental.vrbo_rental.description_pt;
        this.vrboTexts.description_es = newRental.vrbo_rental.description_es;
        this.vrboTexts.accomodations_summary_fr =
          newRental.vrbo_rental.accomodations_summary_fr;
        this.vrboTexts.accomodations_summary_en =
          newRental.vrbo_rental.accomodations_summary_en;
        this.vrboTexts.accomodations_summary_pt =
          newRental.vrbo_rental.accomodations_summary_pt;
        this.vrboTexts.accomodations_summary_es =
          newRental.vrbo_rental.accomodations_summary_es;
        this.map.latitude = newRental.vrbo_rental.latitude;
        this.map.longitude = newRental.vrbo_rental.longitude;
        this.map.showExactLocation = newRental.vrbo_rental.show_exact_location;
        this.vrboAmenitiesSelectedFeatures =
          newRental.vrbo_rental.amenities_features;

        if (newRental.vrbo_rental.bathrooms_features)
          this.vrboBathroomSelectedFeatures =
            newRental.vrbo_rental.bathrooms_features;

        if (
          this.vrboBathroomSelectedFeatures.length < this.rental.bathroom_count
        )
          for (
            var i = this.vrboBathroomSelectedFeatures.length;
            i < this.rental.bathroom_count;
            i++
          ) {
            this.vrboBathroomSelectedFeatures.push({
              type: "FULL_BATH",
              name: { fr: "" },
              description: { fr: "" },
              amenities: [],
            });
          }

        if (newRental.vrbo_rental.bedrooms_features)
          this.vrboBedroomSelectedFeatures =
            newRental.vrbo_rental.bedrooms_features;

        if (this.vrboBedroomSelectedFeatures.length < this.rental.bedroom_count)
          for (
            var i = this.vrboBedroomSelectedFeatures.length;
            i < this.rental.bedroom_count;
            i++
          ) {
            this.vrboBedroomSelectedFeatures.push({
              type: "BEDROOM",
              name: { fr: "" },
              description: { fr: "" },
              amenities: [],
            });
          }
        // add other sleeping area
        if (
          this.vrboBedroomSelectedFeatures.length <
          this.rental.bedroom_count + 1
        )
          this.vrboBedroomSelectedFeatures.push({
            type: "OTHER_SLEEPING_AREA",
            name: { fr: "" },
            description: { fr: "" },
            amenities: [],
          });

        this.vrboPropertySelectedType = newRental.vrbo_rental.property_type;
        this.registrationNumber = newRental.vrbo_rental.registration_number;
        this.unitName = newRental.vrbo_rental.unit_name;
        this.vrboSelectedCurrency = newRental.vrbo_rental.currency;
        this.images = newRental.vrbo_rental.images;
        // init lodging content fields
        this.vrboBookingSelectedPolicy = newRental.vrbo_rental.booking_policy;
        this.vrboCancellationSelectedPolicy =
          newRental.vrbo_rental.cancellation_policy;
        this.vrboPaymentSelectedPolicy = newRental.vrbo_rental.payment_policy;
        this.vrboDefaultCheckin = newRental.vrbo_rental.checkin_time;
        this.vrboDefaultCheckout = newRental.vrbo_rental.checkout_time;
        this.vrboDefaultChildrenEnabled =
          newRental.vrbo_rental.children_enabled;
        this.vrboDefaultEventsEnabled = newRental.vrbo_rental.events_enabled;
        this.vrboDefaultPetsEnabled = newRental.vrbo_rental.pets_enabled;
        this.vrboDefaultSmokingDisabled =
          !newRental.vrbo_rental.smocking_enabled;
        this.maximumOccupancyAdults =
          newRental.vrbo_rental.maximum_occupancy_adults;
        this.maximumOccupancyGuests =
          newRental.vrbo_rental.maximum_occupancy_guests;
        this.merchantName = newRental.vrbo_rental.merchant_name;
        this.minimumAgeRule = newRental.vrbo_rental.minimum_age_rule;
        this.agreementsPdfFileUrl =
          newRental.vrbo_rental.agreements !== null &&
          newRental.vrbo_rental.agreements.length > 0 &&
          newRental.vrbo_rental.agreements[0].url
            ? newRental.vrbo_rental.agreements[0].url
            : "";
        this.customHouseRule1 =
          newRental.vrbo_rental.custom_house_rules_1 !== null
            ? newRental.vrbo_rental.custom_house_rules_1
            : "";
        this.customHouseRule2 =
          newRental.vrbo_rental.custom_house_rules_2 !== null
            ? newRental.vrbo_rental.custom_house_rules_2
            : "";
        this.customHouseRule3 =
          newRental.vrbo_rental.custom_house_rules_3 !== null
            ? newRental.vrbo_rental.custom_house_rules_3
            : "";
      }
    },
  },

  methods: {
    customLabel({ fr_name }) {
      return `${fr_name}`;
    },

    selectImage(event, type) {
      const files = event.target.files || event.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this[type].file = [...files];
      this.isImageSelected = true;
    },

    addImage() {
      if (!this.validateImg()) {
        return;
      }

      this.loading = true;
      const formData = new FormData();
      const files = this.image.file;
      files.forEach((file) => formData.append("image[]", file));
      formData.append("folder", "forms");
      formData.append("rotation", 0);

      fileService
        .uploadImageMulti(this, formData)
        .then((response) => {
          if (response && response.status === 200) {
            const uploadedFiles = response.data.files;

            uploadedFiles.forEach((file) =>
              this.images.push({
                label: this.image.label,
                url: file.path,
                image: file.name,
              })
            );

            this.image.file = {};
            $("#image .add-image")
              .find(".dropify-wrapper")
              .find(".dropify-clear")
              .click();
            this.image.label = "photo";
            this.isImageSelected = false;

            this.loading = false;
          }
        })
        .catch(() => {
          this.isImageSelected = false;
          toastr.error(this.$t("allowed_formats"));

          this.loading = false;
        });
    },

    validateImg() {
      if (
        !Object.values(this.image.file).length ||
        this.image.file.some((f) => !!f.name === false)
      ) {
        toastr.error(this.$t("rentals.website.file_validation_msg"));

        return false;
      }

      return true;
    },

    async deleteUploadedImage(image, index, type) {
      this.imageDeleted = false;
      image.type = type;
      image.rentalId = this.rental.id;
      await websiteService.deleteImage(this, image, index);
      this.imageDeleted = true;
      this.images.splice(index, 1);
    },

    updateImagesOrder(type, images) {
      this.images = images;
    },

    handleLabelChange(field, value) {
      this[field].label = value;
    },

    saveData() {
      let oldImages = [];

      const images = _.cloneDeep(this.images);
      if (images.length > 0) {
        if (images.every((i) => i.order === null)) {
          oldImages = images;
        } else {
          oldImages = images.filter(
            (img) => Object.keys(img).includes("order") && img.order !== null
          );
        }

        let max = Math.max(...oldImages.map((i) => i.order));
        images.map((i) => {
          if (!Object.keys(i).includes("order") || i.order === null) {
            i.order = max + 1;
            max = i.order;
          }
        });
        this.images = images;
      }

      const data = {
        rental_id: this.rental.id,
        property_name_fr: this.vrboTexts.property_name_fr,
        property_name_en: this.vrboTexts.property_name_en,
        property_name_pt: this.vrboTexts.property_name_pt,
        property_name_es: this.vrboTexts.property_name_es,
        headline_fr: this.vrboTexts.headline_fr,
        headline_en: this.vrboTexts.headline_en,
        headline_pt: this.vrboTexts.headline_pt,
        headline_es: this.vrboTexts.headline_es,
        description_fr: this.vrboTexts.description_fr,
        description_en: this.vrboTexts.description_en,
        description_pt: this.vrboTexts.description_pt,
        description_es: this.vrboTexts.description_es,
        accomodations_summary_fr: this.vrboTexts.accomodations_summary_fr,
        accomodations_summary_en: this.vrboTexts.accomodations_summary_en,
        accomodations_summary_pt: this.vrboTexts.accomodations_summary_pt,
        accomodations_summary_es: this.vrboTexts.accomodations_summary_es,
        latitude: this.map.latitude,
        longitude: this.map.longitude,
        show_exact_location: this.map.showExactLocation,
        amenities_features: this.vrboAmenitiesSelectedFeatures,
        bathrooms_features: this.vrboBathroomSelectedFeatures,
        bedrooms_features: this.vrboBedroomSelectedFeatures,
        property_type: this.vrboPropertySelectedType,
        registration_number: this.registrationNumber,
        unit_name: this.unitName,
        currency: this.vrboSelectedCurrency,
        images: this.images,
        booking_policy: this.vrboBookingSelectedPolicy,
        cancellation_policy: this.vrboCancellationSelectedPolicy,
        payment_policy: this.vrboPaymentSelectedPolicy,
        checkin_time: this.vrboDefaultCheckin,
        checkout_time: this.vrboDefaultCheckout,
        children_enabled: this.vrboDefaultChildrenEnabled,
        events_enabled: this.vrboDefaultEventsEnabled,
        pets_enabled: this.vrboDefaultPetsEnabled,
        smocking_enabled: !this.vrboDefaultSmokingDisabled,
        maximum_occupancy_adults: this.maximumOccupancyAdults,
        maximum_occupancy_guests: this.maximumOccupancyGuests,
        merchant_name: this.merchantName,
        minimum_age_rule: this.minimumAgeRule,
        agreements_pdf_file: this.agreementsPdfFile,
        custom_house_rules_1: this.customHouseRule1,
        custom_house_rules_2: this.customHouseRule2,
        custom_house_rules_3: this.customHouseRule3,
      };

      vrboService.vrboUpdateRentalConfig(this, data, this.rental.id);
    },

    updateShowExactLocation() {
      this.map.showExactLocation = !this.map.showExactLocation;
    },

    changeLang() {
      this.property_name = this.vrboTexts[`property_name_${this.activeLang}`];
      this.headline = this.vrboTexts[`headline_${this.activeLang}`];
      this.description = this.vrboTexts[`description_${this.activeLang}`];
      this.accomodations_summary =
        this.vrboTexts[`accomodations_summary_${this.activeLang}`];
    },

    changeUserWebContent(event, type) {
      setTimeout(() => {
        const content = event.target.value;
        this.vrboTexts[`${type}_${this.activeLang}`] = content;
        this[`${type}`] = content;
      }, 0);
    },

    enableChildren() {
      this.vrboDefaultChildrenEnabled = !this.vrboDefaultChildrenEnabled;
    },

    enableEvents() {
      this.vrboDefaultEventsEnabled = !this.vrboDefaultEventsEnabled;
    },

    enablePets() {
      this.vrboDefaultPetsEnabled = !this.vrboDefaultPetsEnabled;
    },

    enableSmoking() {
      this.vrboDefaultSmokingDisabled = !this.vrboDefaultSmokingDisabled;
    },

    uploadAgreementsPdfFile(event) {
      this.loading = true;

      const files = event.target.files || event.dataTransfer.files;

      if (!files.length) {
        this.loading = false;
        return;
      }

      const formData = new FormData();
      formData.append("file", files[0]);
      formData.append("folder", "agreements");

      fileService
        .uploadFile(this, formData)
        .then(() => {
          if (this.uploadedFileFile) {
            this.agreementsPdfFile = {
              label: "vrbo_rental_agreements",
              file: this.uploadedFileFile,
              url: this.uploadedFilePath,
            };

            this.agreementsPdfFileUrl = this.uploadedFilePath;
          }

          this.loading = false;
        })
        .catch(() => {
          toastr.error(this.$t("something_went_wrong"));

          this.loading = false;
        });
    },
  },

  computed: {
    account() {
      return this.$store.state.account;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/rentals/detail/VrboConfigurationTab/VrboConfigurationTab.js